import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddCurrency() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/CurrencyLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Currency"
      alert="Currency Added Successfully"
      addDataAPIEndpoint="/Currency/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Currency Code",
              name: "CL_Code",
              required: true, // Validation rule added here
              maxLength: 40,
            },
            {
              type: "text",
              label: "Currency",
              name: "CL_Name",
              required: true, // Validation rule added here
              maxLength: 40,
            },
            {
              type: "text",
              label: "Currency Symbol",
              name: "CL_Symbol",
              required: true, // Validation rule added here
              maxLength: 5,
            },
          ],
        },
      ]}
      validationRules={{
        CL_Code: {
          required: true,
        },
        CL_Name: {
          required: true,
        },
        CL_Symbol: {
          required: true,
        },
      }}
    />
  );
}

export default AddCurrency;
